import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=696bc58e&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696bc58e')) {
      api.createRecord('696bc58e', component.options)
    } else {
      api.reload('696bc58e', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=696bc58e&", function () {
      api.rerender('696bc58e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormEdit.vue"
export default component.exports